import { TrackingEvent } from "@/common/apis/dtos";
import { TrackingEventWithId } from "@/common/internalModels";
import { FormatLocationWithProperty, IsoToDateAtTime } from "@/common/utilities/display-utilities";
import { GridColDef, GridValueGetterParams, GridValueFormatterParams } from "@mui/x-data-grid-pro";

export function columnDefinitions(translate: (key: string) => string, isOcean: boolean) {
  const columns: GridColDef[] = [
    {
      field: 'eventDate',
      headerName: translate("Event Date / Time"),
      hideable: false,
      valueFormatter: (params: GridValueFormatterParams<any>) => IsoToDateAtTime(params.value, translate),
      filterable: true,
      type: 'Date',
    },
    {
      field: 'location',
      headerName: translate("Location"),
      hideable: false,
      valueGetter: (params: GridValueGetterParams<TrackingEventWithId, any>) => FormatLocationWithProperty(params.row.city, params.row.stateCode, params.row.countryCode),
      filterable: true,
    },
    {
      field: 'notes',
      headerName: translate("Notes"),
      flex: 2,
      hideable: false,
      filterable: true,
    },
    {
      field: 'updatedDateTime',
      headerName: translate("Update Received"),
      hideable: false,
      valueFormatter: (params: GridValueFormatterParams<any>) => IsoToDateAtTime(params.value, translate),
      filterable: true,
      type: 'Date',
    }
  ];

  const containerNumberColumn: GridColDef = {
    field: 'containerNumber',
    headerName: translate("Container Number"),
    hideable: false,
    filterable: true,
  }

  if (isOcean) {
    columns.splice(1, 0, containerNumberColumn);
  }

  const minWidth = 600 / columns.length;
  const columnsWithWidths = columns.map(col => {
    return {
      ...col,
      flex: col.flex ?? 1,
      minWidth: col.flex ? col.flex * minWidth : minWidth,
    }
  });

  return columnsWithWidths;
}